import PropTypes from 'prop-types';
import React from 'react';
import { useDefaultComponentValue } from '../../../utils/useDefaultComponentValue';
import Cross from '../../SvgIcon/Icons/Cross';
import InputControl from '../../TextField/InputControl';
const COMPONENT_NAME = 'DatePickerPanelControls';
const DatePickerPanelControls = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { clearable, controlPanelIconClose, controlPanelIconClear = /*#__PURE__*/ React.createElement(Cross, null), controlPanelIconOpen, disabled, isOpen, onClear, onSelect, readOnly, value, children } = props;
    return /*#__PURE__*/ React.createElement("div", {
        className: "Input-controlPanel-items"
    }, clearable && !disabled && !readOnly && value ? /*#__PURE__*/ React.createElement(InputControl, {
        icon: controlPanelIconClear,
        className: "Select-clearButton",
        onClick: onClear
    }) : null, controlPanelIconOpen && !isOpen ? /*#__PURE__*/ React.createElement(InputControl, {
        disabled: disabled || readOnly,
        icon: controlPanelIconOpen,
        onClick: onSelect
    }) : null, controlPanelIconClose && isOpen ? /*#__PURE__*/ React.createElement(InputControl, {
        disabled: disabled || readOnly,
        icon: controlPanelIconClose,
        onClick: onSelect
    }) : null, children);
};
DatePickerPanelControls.propTypes = {
    children: PropTypes.node,
    clearable: PropTypes.bool,
    controlPanelIconClear: PropTypes.node,
    controlPanelIconClose: PropTypes.node,
    controlPanelIconOpen: PropTypes.node,
    disabled: PropTypes.bool,
    isOpen: PropTypes.bool,
    onClear: PropTypes.func,
    onSelect: PropTypes.func,
    readOnly: PropTypes.bool,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ])
};
export default DatePickerPanelControls;
